const APP_VERSION = process.env['REACT_APP_VERSION']
  ? process.env['REACT_APP_VERSION']
  : '0.0.0'

module.exports = APP_VERSION
